export const APP_STATUSES = {
  LOADING: 'LOADING',
  READY: 'READY',
};

class AppStatus {
  init() {
    this.root = document.getElementById('root');
    this.status = APP_STATUSES.LOADING;
    this.setStatusAttribute();

    window.addEventListener('load', this.setLoaded, { once: true });
  }

  setLoaded = () => {
    this.status = APP_STATUSES.READY;
    this.setStatusAttribute();
  };

  setStatusAttribute() {
    this.root.setAttribute('data-loading-status', this.status);
  }
}

export const appStatus = new AppStatus();
